'use strict';
import React, { Component } from 'react';
import TableHeader from './TableHeader.jsx';
import TableBody from './TableBody.jsx';

class Table extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: props.data
        };
    }

    componentWillReceiveProps(nextProps) {
        this.state.data = nextProps.data;
    }

    render() {
        return (
            <table className="table table-striped">
                <TableHeader data={this.props.data}
                    orderColumn={this.props.orderColumn}
                    selectAllCheckbox={this.props.selectAllCheckbox} />
                <TableBody data={this.props.data}
                    clickCheckbox={this.props.clickCheckbox}
                    routeToEditarProducto={this.props.routeToEditarProducto}  />
            </table>
        );
    }
}

export default Table